import Index from "./index";
import FW_Router from "./router";
import Table from "./templates/table";
import ModalWidget from "./templates/modal";
import Form from "./templates/form";
import AvailableData from "./templates/availableContractsList";
import Plain from "./templates/plain";
import InfoDataPanel from "./templates/infoPanel";
import Footer from "./templates/footer";
import Header from "./templates/header";
import Activate from "../cosmote/templates/activate";

const WHATSUPTemplates = {
  index: Index,
  table: Table,
  form: Form,
  router: FW_Router,
  modal: ModalWidget,
  availableContractsData: AvailableData,
  plain: Plain,
  infoPanel: InfoDataPanel,
  footer: Footer,
  header: Header,
  activatePage: Activate,
};

export default WHATSUPTemplates;
